import React from "react";

export interface SelectOption {
  value: number | string;
  label: string;
}

interface FormSelectProps {
  label: string;

  value: number | string | "";

  options: SelectOption[];

  onChange: (
    value: number | string
  ) => void;
  
  onComplete?: (
    value: number | string
  ) => void;

  placeholder?: string;

  required?: boolean;

  disabled?: boolean;

  error?: string;

  helperText?: string;

  className?: string;
}

export default function FormSelect({
  label,

  value,

  options,

  onChange,

  onComplete,
  
  placeholder = "Select",

  required,

  disabled,

  error,

  helperText,

  className = "",
}: FormSelectProps) {
  return (
    <div className={`space-y-2 ${className}`}>

      <label className="block text-sm font-medium text-slate-700">

        {label}

        {required && (
          <span className="ml-1 text-red-500">*</span>
        )}

      </label>

<select
  value={value}
  disabled={disabled}
  onChange={(e) => {
    const value = e.target.value;

    onChange(value);
    onComplete?.(value);
  }}
  className={`
    w-full
    rounded-lg
    border
    px-3
    py-2.5
    shadow-sm
    transition
    focus:border-blue-500
    focus:outline-none
    focus:ring-2
    focus:ring-blue-200
    disabled:bg-slate-100
    ${
      error
        ? "border-red-500"
        : "border-slate-300"
    }
  `}
>
  <option value="">
  </option>

  {options.map((option) => (
    <option
      key={option.value}
      value={option.value}
    >
      {option.label}
    </option>
  ))}
</select>

      {helperText && !error && (
        <p className="text-xs text-slate-500">
          {helperText}
        </p>
      )}

      {error && (
        <p className="text-xs text-red-500">
          {error}
        </p>
      )}

    </div>
  );
}